import {AUTO_REDIRECT_OPT_OUT_PARAM} from '@packages/systems/localization-constants';
import type {LocaleItemContext} from '../../types';

export function constructUrlForHreflang({
  domain,
  hrefPrefixForHreflangLinks,
  hrefPrefixSameAsCanonicalUrl,
  globalCanonicalTag,
  primaryPageCanonicalUrl,
  locale,
}: {
  domain: string;
  hrefPrefixForHreflangLinks: string | null | undefined;
  hrefPrefixSameAsCanonicalUrl: boolean | null | undefined;
  globalCanonicalTag: string | null | undefined;
  primaryPageCanonicalUrl: string | null | undefined;
  locale: LocaleItemContext;
}) {
  const defaultUrl = `https://${domain}`;
  const localizedPageCanonicalUrl = locale.canonicalUrl;

  // Default case - default back to original behavior
  if (
    !hrefPrefixForHreflangLinks &&
    !globalCanonicalTag &&
    !primaryPageCanonicalUrl &&
    !localizedPageCanonicalUrl
  ) {
    return `${defaultUrl}${locale.pageHref}`.replace(
      AUTO_REDIRECT_OPT_OUT_PARAM,
      ''
    );
  }

  // Don't append any URL structures if either the primary page
  // canonical URL or the localized page canonical URL is set.
  if (localizedPageCanonicalUrl || primaryPageCanonicalUrl) {
    return (localizedPageCanonicalUrl ?? primaryPageCanonicalUrl ?? '').replace(
      AUTO_REDIRECT_OPT_OUT_PARAM,
      ''
    );
  }

  // Append the URL structure if the page canonical URL is not set but
  // either the href prefix or the global canonical tag is set.
  if (
    !primaryPageCanonicalUrl &&
    (hrefPrefixForHreflangLinks || globalCanonicalTag)
  ) {
    const url =
      hrefPrefixSameAsCanonicalUrl || !hrefPrefixForHreflangLinks
        ? globalCanonicalTag
        : hrefPrefixForHreflangLinks;

    return `${url}${locale.pageHref}`.replace(AUTO_REDIRECT_OPT_OUT_PARAM, '');
  }

  // If the page canonical URL is set, use it.
  return defaultUrl;
}
